<template>
  <!-- 最顶部收藏登录 -->
  <div class="top-wrap">
    <div class="content">
      <div class="left">
        <a @mouseenter="mouseEnterFun(1)" @mouseleave="mouseleaveFun(1)">
          APP下载
          <div class="icon" :class="{ up: appshow }"></div>
          <div class="app-img" v-if="appshow"></div>
        </a>
        <div class="line"></div>
        <a @mouseenter="mouseEnterFun(2)" @mouseleave="mouseleaveFun(2)">
          大咖入驻
          <div class="icon" :class="{ up: mastershow }"></div>
          <div class="master-img" v-if="mastershow"></div>
        </a>
        <!-- <template v-if="!isLogin || isAuthor"> -->
        <template>
          <div class="line"></div>
          <a style="cursor: pointer" @click="goAuthorCourse">大咖课程管理</a>
        </template>
        <!--        <div class="line"></div>-->
        <!--        <a>收藏网站</a>-->
      </div>
      <div class="right">
        <template v-if="!isLogin">
          欢迎来到有看投
          <a class="login blue" @click="login">登录</a>
          <div class="line"></div>
          <a class="register blue" @click="login">注册</a>
        </template>
        <el-popover v-else-if="userInfo" placement="bottom-end" width="300" trigger="hover" :visible-arrow="false"
          popper-class="user-info-popover">
          <div>
            <div class="logged-header">
              <base-avatar :src="userInfo.avatar" :size="48"></base-avatar>
              <span class="user-nick">{{ userInfo.nick }}</span>
            </div>
            <div class="logged-mine-container">
              <router-link class="logged-mine" to="/mine" :replace="true">个人主页</router-link>
              <router-link class="logged-follow" to="/mine/follow" :replace="true">我的关注</router-link>
              <router-link class="logged-currency" to="/mine/vcurrency" :replace="true">我的财币</router-link>
            </div>
            <div class="logged-login">
              <router-link class="logged-edit" to="/mine/info">修改信息</router-link>
              <a class="logged-exit" @click="logout">退出登录</a>
            </div>
          </div>
          <div slot="reference" class="user-info">
            <base-avatar :src="userInfo.avatar" :size="20"></base-avatar>
            <span>{{ userInfo.nick }}</span>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import BaseAvatar from '@/components/BaseAvatar/BaseAvatar'

export default {
  name: 'TopStatusBar',
  components: { BaseAvatar },
  data() {
    return {
      appshow: false,
      mastershow: false
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters['auth/isLogin']
    },
    userInfo() {
      return this.$store.state.user.userInfo
    },
    isAuthor() {
      return this.userInfo ? this.userInfo.isAuthor : false
    }
  },
  methods: {
    mouseEnterFun(type) {
      if (type === 1) {
        this.appshow = true
      } else {
        this.mastershow = true
      }
    },
    mouseleaveFun(type) {
      if (type === 1) {
        this.appshow = false
      } else {
        this.mastershow = false
      }
    },
    login() {
      if (this.isLogin) {
        this.$notify({
          title: '通知',
          message: '你已登录',
          type: 'warning'
        })
        return
      }

      this.$store.dispatch('auth/login')
    },
    goAuthorCourse() {
      // 大咖管理端
      // this.$router.push({ path: '/author-course' })
      if (!this.isLogin) {
        this.$store.dispatch('auth/login')
        return
      }

      this.$router.push({ path: '/author-course' })
    },
    logout() {
      this.$store.dispatch('auth/logout')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/style/variable/index.scss';

.content {
  width: $page-width;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon {
  width: 8px;
  height: 14px;
  background: url('./images/arrow.png') no-repeat;
  background-size: cover;
  transform: rotate(90deg);
  margin-left: 6px;

  &.up {
    transform: rotate(-90deg);
  }
}

.line {
  width: 1px;
  height: 8px;
  margin: 3px 14px 0;
  background-color: #858585;
}

.top-wrap {
  background-color: #f0f0f0;
  height: 30px;
  font-size: 12px;
  color: #262626;

  .left {
    display: flex;
    cursor: pointer;

    a {
      position: relative;
      display: flex;
    }

    .app-img {
      position: absolute;
      width: 200px;
      height: 200px;
      background: url('./images/app.png') no-repeat;
      background-size: cover;
      left: -20px;
      top: 20px;
    }

    .master-img {
      position: absolute;
      width: 200px;
      height: 200px;
      background: url('./images/master.jpg') no-repeat;
      background-size: cover;
      left: -20px;
      top: 20px;
    }
  }

  .right {
    display: flex;

    .blue {
      color: #046bcc;
    }

    .login {
      margin-left: 10px;
      cursor: pointer;
    }

    .register {
      cursor: pointer;
    }
  }
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  color: #262626;

  ::v-deep .avatar {
    margin-right: 10px;
  }
}

.logged-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 114px;
  background: rgba(#046bcc, 0.1) url('./images/bg.png') no-repeat center;
  background-size: cover;

  .user-nick {
    padding-top: 12px;
    font-size: 16px;
    color: #262626;
  }
}

.logged-mine-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 80px;

  .logged-mine,
  .logged-follow,
  .logged-currency {
    padding-top: 28px;
    background: no-repeat top;
    background-size: 18px auto;
    font-size: 14px;
    color: #858585;
    text-decoration: none;
  }

  .logged-mine {
    background-image: url('~@/assets/images/icons/icon-mine.png');
  }

  .logged-follow {
    background-image: url('~@/assets/images/icons/icon-follow.png');
  }

  .logged-currency {
    background-image: url('~@/assets/images/icons/icon-currency.png');
  }
}

.logged-login {
  display: flex;
  align-items: center;
  height: 46px;
  border-top: 1px solid #ebebeb;
  text-align: center;

  .logged-edit {
    position: relative;
    text-decoration: none;

    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 14px;
      background-color: #ebebeb;
    }
  }

  .logged-edit,
  .logged-exit {
    flex: auto;
    font-size: 14px;
    color: #262626;
    cursor: pointer;
  }
}
</style>

<style lang="scss">
body .user-info-popover {
  margin-top: 5px !important;
  padding: 0;
  border-radius: 0;
  border: none;
}
</style>
